export default __webpack_public_path__ + "static/media/spotify.f055fc2b.png";